import { usePaymentMethodValues } from '@olo-web/domain/payments/hooks';
import { Flex, Text } from '@chakra-ui/react';

export const MobilePayContactInfo = () => {
  const { isApplePay } = usePaymentMethodValues();
  const text = isApplePay ? 'Apple Pay.' : ' Google Pay.';
  return (
    <Flex
      align="flex-start"
      justify={{ base: 'space-between', md: 'flex-start' }}
      flex={1}
      maxW="100%"
      w={{ base: '100%', md: 'auto' }}
      role="alert"
      aria-live="polite"
    >
      <Text fontSize="sm" data-testid="text-row-text">
        Your contact information will be shared through {text}
      </Text>
    </Flex>
  );
};
